import { Link } from 'react-router-dom';

const THIRD_PARTY_LICENSES = [
  { name: 'React', license: 'MIT', url: 'https://github.com/facebook/react' },
  { name: 'React Router', license: 'MIT', url: 'https://github.com/remix-run/react-router' },
  { name: 'Leaflet', license: 'BSD-2-Clause', url: 'https://github.com/Leaflet/Leaflet' },
  { name: 'react-leaflet', license: 'Hippocratic-2.1', url: 'https://github.com/PaulLeCam/react-leaflet' },
  { name: 'i18next', license: 'MIT', url: 'https://github.com/i18next/i18next' },
  { name: 'Lucide Icons', license: 'ISC', url: 'https://github.com/lucide-icons/lucide' },
  { name: 'Stripe.js', license: 'MIT', url: 'https://github.com/stripe/stripe-js' },
  { name: 'Supabase JS', license: 'MIT', url: 'https://github.com/supabase/supabase-js' },
  { name: 'Flask', license: 'BSD-3-Clause', url: 'https://github.com/pallets/flask' },
  { name: 'Gunicorn', license: 'MIT', url: 'https://github.com/benoitc/gunicorn' },
];

const DATA_ATTRIBUTIONS = [
  { name: 'OpenStreetMap', usage: 'Map tiles and reverse geocoding', url: 'https://www.openstreetmap.org/copyright' },
  { name: 'NYC Open Data', usage: 'TLC vehicle license verification', url: 'https://opendata.cityofnewyork.us/' },
  { name: 'Chicago Open Data', usage: 'BACP vehicle license verification', url: 'https://data.cityofchicago.org/' },
  { name: 'NHTSA', usage: 'VIN decoding', url: 'https://vpic.nhtsa.dot.gov/api/' },
];

export default function Licenses() {
  return (
    <div className="app-container">
      <div className="app-wrapper">
        <div className="app-card">
          <div className="app-header">
            <h1>Open Source Licenses</h1>
            <p>RideshareChecker is built with the help of these open source projects and data sources.</p>
          </div>

          <div className="terms-section" style={{ padding: '0 24px 24px' }}>
            <h3>Third-Party Libraries</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '24px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e5e7eb', textAlign: 'left' }}>
                  <th style={{ padding: '8px 0' }}>Library</th>
                  <th style={{ padding: '8px 0' }}>License</th>
                </tr>
              </thead>
              <tbody>
                {THIRD_PARTY_LICENSES.map((lib) => (
                  <tr key={lib.name} style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '8px 0' }}>
                      <a href={lib.url} target="_blank" rel="noopener noreferrer">{lib.name}</a>
                    </td>
                    <td style={{ padding: '8px 0' }}>{lib.license}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <h3>Data Sources</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '24px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e5e7eb', textAlign: 'left' }}>
                  <th style={{ padding: '8px 0' }}>Source</th>
                  <th style={{ padding: '8px 0' }}>Usage</th>
                </tr>
              </thead>
              <tbody>
                {DATA_ATTRIBUTIONS.map((source) => (
                  <tr key={source.name} style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '8px 0' }}>
                      <a href={source.url} target="_blank" rel="noopener noreferrer">{source.name}</a>
                    </td>
                    <td style={{ padding: '8px 0' }}>{source.usage}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <p style={{ fontSize: '14px', color: '#6b7280' }}>
              For complete license texts, please visit the respective project repositories linked above.
            </p>

            <div style={{ marginTop: '24px' }}>
              <Link to="/" style={{ color: '#3b82f6' }}>Back to App</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
